export default "__VITE_ASSET__C0Nl41Ws__"